module.exports = __webpack_public_path__ + "img/instagram.7ff1c46f.png";